<div
  *ngIf="parentFormGroup &&
          parentFormGroup.controls &&
          parentFormGroup.controls[this.controlName]"
>
  <div
    class="form-field-label mb-[0.8rem] {{type}}"

    *ngIf="label"
  >
    {{label}}
    <span
      *ngIf="isRequired"
      class="required-mark"
    >*</span>
  </div>
  <mat-form-field
    [formGroup]="parentFormGroup"
    appearance="outline"
    class="form-field"
    [ngClass]="type ? 'small' : ''"
    hideRequiredMarker
  >
    <textarea
      #textarea
      class="text-area {{type}}"
      [formControlName]="controlName"
      [maxlength]="maxLength"
      rows="4"
      matInput
      placeholder="{{placeholder}}"
    >
    </textarea>
    <mat-error *ngIf="error">{{error}}</mat-error>
    <div
      class="char-count flex w-full justify-end items-center mt-[0.5rem]"
      *ngIf="showCharCount"
    >
      {{ (parentFormGroup?.controls[controlName]?.value?.length || 0) }}/{{
      maxLength }}
    </div>
  </mat-form-field>

</div>
